import React, { useState, useRef } from 'react'
import mixpanel from 'mixpanel-browser';

import { Modal, Button, Icon, Image } from 'semantic-ui-react'

import { Game, Tournament } from '../types'

import { useNavigate } from 'react-router-dom'
import { useMeleeContext } from 'draft/context/MeleeContextProvider'

import { NewRound } from 'draft/utils/roundHandler'

import { draftToTrackData, DraftType, Player, Team, TournamentGameDetails } from 'draft/types'
import { getHeroImage } from 'draft/heroes/useHeroes'

import { GetStageImage } from 'draft/stages/stage'

const GameModal = (props: {
    open: boolean
    triggerModal: (isOpen: boolean) => void
    declareWinner: (winner: ('blue' | 'red'), stockDifference: number) => void
    Tornament: Tournament,
    game: Game,
    openManualDraft: () => void
}) => {
    const navigate = useNavigate();
    const meleeContext = useMeleeContext();

    const [showForceShowDraftButton, setshowForceShowDraftButton] = useState(false);
    const [overWriteWarning, setOverWriteWarning] = useState(false);

    const [stockDifferenceInput, setStockDifferenceInput] = useState(NaN);
    const stockInputRef = useRef<HTMLInputElement>(null);

    const [winners, setWinners] = useState<('' | 'blue' | 'red')>('');

    const teamButtonOnClick = (winner: ('blue' | 'red')) => {
        setWinners(winner);
        stockInputRef.current && stockInputRef.current.focus();
    }

    const createPlayerList = (): Player[] => {
        let draftPlayers: Player[] = [];

        props.game.TeamBlue.forEach((p, i) => {
            var newPlayer: Player = {
                Number: i + 1,
                Name: p.Name,
                Team: Team.Blue,
                TournamentPlayerNumber: p.Number
            }
            draftPlayers.push(newPlayer);
        })

        props.game.TeamRed.forEach((p, i) => {
            var newPlayer: Player = {
                Number: i + 3,
                Name: p.Name,
                Team: Team.Red,
                TournamentPlayerNumber: p.Number
            }
            draftPlayers.push(newPlayer);
        })
        return draftPlayers;
    }

    const generateTournamentGameAndNavigate = () => {
        if (!meleeContext) throw new Error("Melee Context Broken");

        var tournamentDetails: TournamentGameDetails = {
            GameId: props.game.Id,
            TournamentId: props.game.TournamentId,
            GameName: props.game.Name
        }

        const roundData = NewRound(createPlayerList(), props.Tornament.DraftOptions, tournamentDetails, DraftType.Teams);

        mixpanel.track("Tournament Draft Started",
            { "data": draftToTrackData(roundData) }
        )

        meleeContext.setGameData(roundData);
        navigate(`/draft`);
    }

    const openGameDraft = () => {
        if (meleeContext?.gameData.Active) {
            setOverWriteWarning(true)
            return;
        }
        generateTournamentGameAndNavigate();
    }

    const validForm = !Number.isNaN(stockDifferenceInput) && stockDifferenceInput >= 0 && winners !== '';

    const submitWinners = () => {
        if (winners === '') throw new Error("Can't declare winners - no winners selected");
        props.declareWinner(winners, stockDifferenceInput);
    }

    //Check draft completion
    let isDoneWithDraft = true;
    props.game.TeamBlue.forEach(p => {
        if (!p.Hero) isDoneWithDraft = false;
    })
    props.game.TeamRed.forEach(p => {
        if (!p.Hero) isDoneWithDraft = false;
    })
    // {props.game.Heat && <p style={{margin:'-.5em 0 1em 0'}} className='game-name'>Heat {props.game.Heat}</p>}
    return (
        <Modal
            open={props.open}
            onClose={() => props.triggerModal(false)}
            style={{ textAlign: 'center' }}
            className='melee-modal'
        >
            <Modal.Content >

                <h2>{props.game.Name ? props.game.Name : props.game.Id}</h2>
                

                {!isDoneWithDraft || showForceShowDraftButton ? (
                    !overWriteWarning ? (
                        <div style={{ display: 'inline-grid' }}>
                            <button
                                className="massive melee-button"
                                style={{ marginTop: 8 }}
                                onClick={openGameDraft}
                            >
                                Draft!
                            </button>
                            <button
                                className="melee-inline-button"
                                style={{ marginTop: '1em', fontSize: '0.9em' }}
                                onClick={() => props.openManualDraft()}
                            >
                                Manual draft
                            </button>
                        </div>
                    ) : (
                        <div>
                            <p><Icon name="warning" /> You currently have an ongoing draft. Want to override?</p>
                            <button
                                className="massive melee-button"
                                onClick={generateTournamentGameAndNavigate}
                            >
                                Override
                            </button>
                            <button
                                className="massive melee-button"
                                onClick={() => navigate("/draft")}
                            >
                                Go to current draft
                            </button>
                        </div>
                    )) : (
                    <div >
                        <button
                            onClick={() => setshowForceShowDraftButton(true)}
                            className="melee-inline-button">
                            Reset draft
                        </button>
                    </div>
                )
                }

                <h4>
                    Select winner and type in stock difference
                </h4>
                <div className='radio-team-container'>
                    <button
                        className={`radio-team-button blue ${winners === 'blue' ? 'selected' : ''}`}
                        onClick={() => teamButtonOnClick('blue')}
                    >
                        {props.game.TeamBlue.map(p => <h4>{p.Name} {p.Hero && <Image style={{ width: 32, margin: 'auto' }} src={getHeroImage(props.Tornament.DraftOptions.gameType, p.Hero)} />}</h4>)}
                    </button>
                    {props.game.Stage &&
                        <div className='showcase-item' style={{ margin: '5% 0 5% 0' }}>
                            <img className='melee-stage-img' alt={"Stage"} src={GetStageImage(props.game.Stage, props.Tornament.DraftOptions.gameType)} />
                            <div className='text-container'>
                                <h5>{props.game.Stage.Name}</h5>
                            </div>
                        </div>
                    }
                    <button
                        className={`radio-team-button red ${winners === 'red' ? 'selected' : ''}`}
                        onClick={() => teamButtonOnClick('red')}
                    >
                        {props.game.TeamRed.map(p => <h4>{p.Name} {p.Hero && <Image style={{ width: 32, margin: 'auto' }} src={getHeroImage(props.Tornament.DraftOptions.gameType, p.Hero)} />}</h4>)}
                    </button>
                </div>

                <h5>Stock Difference:</h5>
                <input
                    value={stockDifferenceInput}
                    onChange={(e) => setStockDifferenceInput(e.target.valueAsNumber)}
                    type="number" style={{ maxWidth: 80 }}
                    ref={stockInputRef}
                />

                <div className="action">
                    <Button
                        style={{ margin: "32px 0 32px 0", padding: "1em" }}
                        color={winners === '' ? 'grey' : winners}
                        disabled={!validForm}
                        onClick={() => submitWinners()}
                        icon
                        labelPosition='left'
                    >
                        <Icon name='winner' />
                        Declare winner
                    </Button>
                </div>

            </Modal.Content>
        </Modal>
    )
}

export default GameModal;